const SORT_BY_DISTANCE_VALUE = 'distance';
const SORT_BY_ATOZ_VALUE = 'atoz';

export const SORT_BY_OPTIONS = [
  { value: SORT_BY_ATOZ_VALUE, label: 'Sort by: A to Z' },
  { value: SORT_BY_DISTANCE_VALUE, label: 'Sort by: Distance' },
];
